/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const BusinessRole = {
    NotSpecified: 'NotSpecified',
    BalanceResponsibleParty: 'BalanceResponsibleParty',
    GridAccessProvider: 'GridAccessProvider',
    BalancePowerSupplier: 'BalancePowerSupplier',
    ImbalanceSettlementResponsible: 'ImbalanceSettlementResponsible',
    MeteringPointAdministrator: 'MeteringPointAdministrator',
    MeteredDataAggregator: 'MeteredDataAggregator',
    SystemOperator: 'SystemOperator',
    MeteredDataResponsible: 'MeteredDataResponsible',
} as const;
export type BusinessRole = typeof BusinessRole[keyof typeof BusinessRole];

